import AppForecastUtils from "../src/utils/appForecast.utils";
import { mapState } from "vuex";
import ForecastService from "../src/services/forecastService";
import { serverAddr } from "../src/networkConfig.js";
import { EventBus } from "../src/eventBus";

export const AppForecastTabNC = {
	computed: {
		...mapState("AppForecastStore", [
			"basicsStore",
			"num_daysStore",
			"periodStore",
			"aggregateStore"
		])
	},
	methods: {
		postInputChanged(tableData, mappedIds) {
			// if (this.aggregate == "day"postInputChanged || this.aggregate == "week") {
			return AppForecastUtils.getDayTableData(
				tableData,
				mappedIds,
				this.basics,
				this.period,
				this.getAggreate,
				this.include_start_day,
				this.$route.name
			);

			// console.log("tableRows", tableRows);
			// }
		},
		currentDate() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = "0" + dd;
			}

			if (mm < 10) {
				mm = "0" + mm;
			}

			today = yyyy + "-" + mm + "-" + dd;
			return today;
			// console.log("today", today);
		},
		isEmptyObject(obj) {
			for(var prop in obj) {
			  if(Object.prototype.hasOwnProperty.call(obj, prop)) {
				return false;
			  }
			}
		  
			return JSON.stringify(obj) === JSON.stringify({});
		},
		inputChanged(queryObject, pageInfo) {
			// console.log("pae infor in input changed", queryObject);
			return this.fetchForecast({
				queryObject: queryObject,
				pageInfo: pageInfo
			})
				.then(tableData => {
					if (this.basics == "date") {
						return { ids: [], tableData: tableData };
					}
					var ids = tableData.map(obj => {
						return Object.keys(obj)[0];
					});
					return { ids: ids, tableData: tableData };
				})
				.then(response => {
					// console.log("response ", response, this.basics);
					if (this.basics == "date") {
						return { tableData: response.tableData, mappedIds: [] };
					}
					return ForecastService.mapIds({
						basics: this.basics,
						id_list: response.ids
					})
						.then(mappingOfIds => {
							// console.log("mappingOfIds", mappingOfIds);
							var mappedIds = JSON.parse(mappingOfIds.data);
							return { tableData: response.tableData, mappedIds: mappedIds };
						})
						.catch(error => {
							throw error;
						});
				})
				.then(response => {
					EventBus.$emit("disableFirstButton", false);
					const final = this.postInputChanged(
						response.tableData,
						response.mappedIds
					);
					// console.log("finsa", final);
					this.$store.commit("AppForecastStore/FORECAST_ANALYTICS", final);
					// this.include_start_day = false;
					// this.buttonClicked.isClicked = false;
					// this.buttonClicked.isWeekClick = false;
				})
				.catch(error => {
					EventBus.$emit("disableFirstButton", false);
					console.error(error);
				});
		},
		currentDateDDMMYYYY() {
			var today = new Date();
			var dd = today.getDate();
			var mm = today.getMonth() + 1; //January is 0!
			var yyyy = today.getFullYear();

			if (dd < 10) {
				dd = "0" + dd;
			}

			if (mm < 10) {
				mm = "0" + mm;
			}

			today = dd + "-" + mm + "-" + yyyy;
			return today;
			// console.log("today", today);
		}
		// isChildPresent(id, child, arr) {
		// 	// takes id of parent and name of child and an array of the heirarchy of the fields
		// 	// if a child is present the function return true,
		// 	function searchChildField(arr) {
		// 		return arr.some(obj => {
		// 			if (obj.id == id) {
		// 				return child in obj;
		// 			}
		// 			return Object.keys(obj).some(key => {
		// 				if (Array.isArray(obj[key])) {
		// 					return searchChildField(obj[key]);
		// 				}
		// 			});
		// 		});
		// 	}
		// 	return searchChildField(arr) ? true : false;
		// }
		// consolidated() {
		// 	this.isConsolidated = true;
		// 	return this.fetchForecast(queryObject).catch(error => {
		// 		console.log(error);
		// 	});
		// },
		// inputChanged() {
		// 	axios.all([this.unConsolidated()]).then(
		// 		axios.spread(tableData => {
		// 			console.log("spread", "tableData", tableData);
		// 			const final = this.postInputChanged(
		// 				tableData.tableData,
		// 				tableData.mappedIds
		// 			);
		// 			console.log("finsa", final);
		// 			this.$store.commit("AppForecastStore/FORECAST_ANALYTICS", final);
		// 		})
		// 	);
		// }
	}
};
